document.addEventListener('DOMContentLoaded', () => {
	// Default Settings
	const defaultSettings = {
		loop: true,
		speed: 700,
		effect: 'fade',
		fadeEffect: {crossFade: true},
		navigation: {nextEl: '.swiper-next', prevEl: '.swiper-prev'},
		autoplay: {delay: 5000, disableOnInteraction: false},
	}

	// Initialize Swiper
	const initializeSwiper = (element, index) => {
		const swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper): defaultSettings
		element.setAttribute(`data-swiper-${index}`, '')
		return new Swiper(`[data-swiper-${index}]`, swiperConfig)
	}
    
	// Initialize Swipers
	const allSwipers = []
	document.querySelectorAll('.swiper-slider').forEach((element, index) => {
		const swiper = initializeSwiper(element, index)
		allSwipers.push(swiper)

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting && swiper.passedParams.autoplay) {
						swiper.autoplay.start()
					} else {
						swiper.autoplay.stop()
					}
				})
			},
			{
				threshold: 0.5,
			},
		)

		observer.observe(element)
	})
	
	allSwipers.forEach((mainSwiper) => {
        const targetSelector = mainSwiper.params.customcontrol;
        if (targetSelector) {
            const selectorClean = targetSelector.startsWith('#') ? targetSelector : `#${targetSelector}`;
            let targetElement = null;
            try { targetElement = document.querySelector(selectorClean); } catch(e) {}
            if (targetElement) {
                const targetSwiper = allSwipers.find(s => s.el === targetElement);
                if (targetSwiper) {
                    const isLoopEnabled = mainSwiper.params.loop;
                    if (isLoopEnabled) {
                        mainSwiper.on('slideChange', () => {
                            const index = mainSwiper.realIndex;
                            if (targetSwiper.realIndex !== index) {
                                targetSwiper.slideToLoop(index, mainSwiper.params.speed);
                            }
                        });
                        mainSwiper.on('transitionEnd', () => {
                             if (targetSwiper.realIndex !== mainSwiper.realIndex) {
                                 targetSwiper.slideToLoop(mainSwiper.realIndex, mainSwiper.params.speed);
                             }
                        });
                    } 
                    else {
                        mainSwiper.controller.control = targetSwiper;
                    }
                }
            }
        }
    });

	const galleryMainContainer = document.getElementById('main-gallery');
    let galleryMain;

    if (galleryMainContainer) {
        galleryMain = new Swiper('#main-gallery', {
            loop: true,
            speed: 700,
			pagination: {
				el: '.gallery-block__dots',
				type: 'bullets',
				clickable: true,
				dynamicBullets: true,
				dynamicMainBullets: 3
			},
			slidesPerView: 1.35,
			centeredSlides: true,
			spaceBetween: 15,
			navigation: {
				nextEl: ".gallery-arrow-next",
				prevEl: ".gallery-arrow-prev",
			},
			autoplay: {delay: 5000, disableOnInteraction: false},
			breakpoints: {
				769: {
					slidesPerView: 3,
					centeredSlides: false,
					pagination: {
						el: '.gallery-block__dots',
						type: 'bullets',
						clickable: true,
						dynamicBullets: false,
						dynamicMainBullets: null
					},
				}
			},
        });
    }

    const galleryOtherContainer = document.getElementById('other-gallery');
    let galleryOther;

    if (galleryOtherContainer) {
        galleryOther = new Swiper('#other-gallery', {
            loop: true,
			speed: 700,
			effect: "fade",
			fadeEffect: {crossFade: true},
        });
    }

    if (galleryMain && galleryOther) {
        galleryMain.controller.control = galleryOther;
        galleryOther.controller.control = galleryMain;
    }

})
